import './Card3.css'

const Card2 = () => {
  return (
    <>
    <div className='title_con2'>
      
    </div>
    <div className='grid-container_car'>
        <div className='card_con'>
            <div className='wrapper'>
                <div className='card_area'>
                    <div className='card'>
                        <a id="pic" href="#pic"><img class="car_thumb" src="" />
                            <span class="car_full"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="pic2" href="#pic2"><img class="car_thumb2" src="" />
                            <span class="car_full2"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="pic3" href="#pic3"><img class="car_thumb3" src="" />
                            <span class="car_full3"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card4'>
                        <a id="pic4" href="#pic4"><img class="car_thumb4" src="" />
                            <span class="car_full4"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="pic5" href="#pic5"><img class="car_thumb5" src="" />
                            <span class="car_full5"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="pic6" href="#pic6"><img class="car_thumb6" src="" />
                            <span class="car_full6"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="pic7" href="#pic7"><img class="car_thumb7" src="" />
                            <span class="car_full7"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="pic8" href="#pic8"><img class="car_thumb8" src="" />
                            <span class="car_full8"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="pic9" href="#pic9"><img class="car_thumb9" src="" />
                            <span class="car_full9"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="pic10" href="#pic10"><img class="car_thumb10" src="" />
                            <span class="car_full10"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="pic11" href="#pic11"><img class="car_thumb11" src="" />
                            <span class="car_full11"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="pic12" href="#pic12"><img class="car_thumb12" src="" />
                            <span class="car_full12"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                    <div className='card'>
                        <a id="pic13" href="#pic13"><img class="car_thumb13" src="" />
                            <span class="car_full13"><img src="" /></span>
                        </a>
                        <a class="cssbox_close" href="#void"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</>
  )
}

export default Card2